import React from 'react';
import SideNavBar from '../../../SideNavBar';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';

export interface Props {
  activeHash: string;
  updateActiveHash: (hash: string) => void;
  routes: any;
}

export const StatsSideNavBar: React.FC<Props> = ({
  activeHash,
  updateActiveHash,
  routes,
}) => (
  <SideNavBar
    routes={routes}
    activeHash={activeHash}
    onActiveHashChange={updateActiveHash}
    biEvid={BiEventType.PROFILE_STATS_SIDEBAR}
  />
);
StatsSideNavBar.displayName = 'StatsSideNavBar';

export default StatsSideNavBar;
